import { RootState } from '@checkout/state';
import * as React from 'react';
import { connect } from 'react-redux';
import { fetchKCOWidgetRequest } from '../../../reducers/checkout';
import { Widget } from '../../presentational';

interface IOwnProps {}

interface IConnectedProps {
  widgets: any;
  selectedPaymentMethod: string;
}

interface IConnectetDispatchProps {
  fetchKCOWidgetRequest: typeof fetchKCOWidgetRequest;
}

type Props = IOwnProps & IConnectedProps & IConnectetDispatchProps;

class KlarnaCheckout extends React.Component<Props, {}> {

  componentDidMount() {
    // if (Object.keys(this.props.widgets).length === 0) {
      this.props.fetchKCOWidgetRequest();
    // }
  }

  render() {
    const { widgets, selectedPaymentMethod } = this.props;
    if (Object.keys(widgets).length === 0 && widgets.constructor === Object) { return null; }

    const snippet = widgets[selectedPaymentMethod];

    return (
      <Widget snippet={snippet} selectedPaymentMethod={selectedPaymentMethod} evaluateDelay={300} />
    );
  }
}

export default connect<IConnectedProps, IConnectetDispatchProps>(
  (state: RootState) => ({
    widgets: state.checkout.widgets,
    selectedPaymentMethod: state.checkout.selection.paymentMethod,
  }),
  {
    fetchKCOWidgetRequest
  }
)(KlarnaCheckout);
